module.exports = __webpack_public_path__ + "img/star.0fe73ebe.svg";